globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.MainController = (function(superClass) {

  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function(){
      $(".site-screenshot.request-screenshot").each(function() {
        appCustomerSpace.Modules.Websites.VersionScreenshot.request($(this));
      });

      $(".company-profile-screenshot.request-screenshot").each(function() {
        appCustomerSpace.Modules.LocalManagement.CompanyProfileScreenshot.request($(this));
      });

      appCustomerSpace.Modules.LocalManagement.MulticastSyncOrdersSidebar.init();

      SearchFilter.initFilters($('.multicast-notice-search-input-filter'));

      queryString = window.location.search;
      if(queryString.includes('updated_criteria')){
        criteria = queryString.replace(new RegExp(/.+updated_criteria\[\]=/g),'').replace(new RegExp(/,.+/g),'');
        if(criteria.length > 0){
          var $criteriaModalOpener = $(`.optimization-criteria-modal-opener[data-criteria-key=${criteria}]`);
          if($criteriaModalOpener != undefined){
            $criteriaModalOpener.addClass('trigger-click-on-load');
          }
        }
      }

      return MainController.__super__.init.apply(this, arguments);
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.MainController);
